import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = true
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 w-full overflow-hidden ${dark ? 'bg-navy-900 text-cream-50' : 'bg-cream-50 text-navy-900'} ${className}`} data-id="element-213">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-214">
        {children}
      </motion.div>
    </section>;
}